<template>
  <v-card class="ma-5" outlined>
    <v-toolbar flat>
      <v-toolbar-title>{{ title }}</v-toolbar-title>
      <v-spacer />
      <v-col cols="4">
        <search-labo :id="$route.query._id" :clearable="true" :outlined="true" :dense="true" @emit-labo="updateSearch" />
      </v-col>
      <sync-button type="accounts" :exec="syncAccounts" />
      <filters
        :filters="filters"
        :options="options"
        :fetcher="fetchLabs"
        @fetching="loading = $event"
        @fetchedResults="labos = $event"
        @fetchedTotal="total = $event"
      />
      <columns :headers="headers" @emit-headers="filteredHeaders = $event" />
    </v-toolbar>
    <v-data-table
      class="ma-5"
      :headers="filteredHeaders"
      :items="labos"
      :loading="loading"
      :loading-text="$t('common.loading')"
      :server-items-length="total"
      :options.sync="options"
      :sort-by="sortBy"
      :sort-desc="sortDesc"
    >
      <template #no-data> {{ $t('labotable.nodata1') }} {{ title }} {{ $t('labotable.nodata2') }} </template>
      <template #item="props">
        <tr>
          <td v-if="showColumn('name')">
            {{ props.item.name }}
          </td>
          <td v-if="showColumn('en')">
            {{ props.item.translations.en }}
          </td>
          <td v-if="showColumn('fr')">
            {{ props.item.translations.fr }}
          </td>
          <td v-if="showColumn('account')">
            {{ accountName(props.item.account) }}
          </td>
          <td v-if="showColumn('price')">
            {{ props.item.price ? '€ ' + props.item.price.toFixed('2') : '-' }}
          </td>
          <td v-if="showColumn('fixedPrice')">
            <v-icon v-if="props.item.fixedPrice" class="green--text"> mdi-check </v-icon>
          </td>
          <td v-if="showColumn('tax')">
            {{ props.item.tax }}
          </td>
          <td v-if="showColumn('action')" class="text-right d-print-none">
            <v-tooltip bottom>
              <template #activator="{ on }">
                <v-icon dark color="primary" class="mr-2" @click="() => openLaboPage(props.item._id)" v-on="on"> mdi-pencil </v-icon>
              </template>
              <span>{{ $t('labotable.edit') }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template #activator="{ on }">
                <v-icon dark color="primary" @click="() => openDeleteDialog(props.item)" v-on="on"> mdi-delete </v-icon>
              </template>
              <span>{{ $t('labotable.delete') }}</span>
            </v-tooltip>
          </td>
        </tr>
      </template>
    </v-data-table>
    <delete-dialog
      :delete-dialog="deleteDialog"
      item="Labo-onderzoek"
      :delete-queue="deleteQueue"
      @delete="deleteItem"
      @close="closeDeleteDialog"
    />
  </v-card>
</template>

<script>
import { accountName, compareRouteAndPush } from '@/Helpers';
import { laboAPI, teamleaderAPI } from '@/services';
import DeleteDialog from '@/components/common/DeleteDialog';
import SearchLabo from '@/components/search/SearchLabo';
import SyncButton from '@/components/common/SyncButton';
import Filters from '@/components/filters/Filters';
import Columns from '@/components/filters/Columns';

export default {
  components: { Filters, Columns, DeleteDialog, SearchLabo, SyncButton },
  props: {
    title: { type: String, default: '' },
    headers: { type: Array, required: true },
    filters: { type: Object, default: () => ({}) },
  },
  data: (data) => ({
    filteredHeaders: [],
    labos: [],
    total: 0,
    loading: false,
    options: {
      page: Number(data.$route.query.page) || 1,
      itemsPerPage: Number(data.$route.query.limit) || 10,
    },
    deleteDialog: false,
    deleteQueue: {},
    sortBy: 'name',
    sortDesc: false,
  }),
  watch: {
    options: {
      immediate: true,
      deep: true,
      handler() {
        this.compareRouteAndPush(
          {
            ...this.$route.query,
            page: this.options.page,
            limit: this.options.itemsPerPage,
            sortBy: this.options.sortBy,
            sortDesc: this.options.sortDesc,
          },
          this.$route,
          this.$router
        );
      },
    },
  },
  methods: {
    accountName,
    compareRouteAndPush,
    openLaboPage(id) {
      this.$router.push(`/settings/labo/${id}`);
    },
    showColumn(col) {
      return this.headers.find((header) => header.value === col).selected;
    },
    updateSearch(lab) {
      this.compareRouteAndPush(
        {
          ...this.$route.query,
          _id: lab ? lab._id : undefined,
        },
        this.$route,
        this.$router
      );
    },
    openDeleteDialog(item) {
      this.deleteQueue = item;
      this.deleteDialog = true;
    },
    closeDeleteDialog(state) {
      this.deleteQueue = {};
      this.deleteDialog = state;
    },
    async syncAccounts() {
      await teamleaderAPI.syncAccounts();
      await this.getAllLabos();
    },
    async deleteItem(item) {
      try {
        this.loading = true;
        await this.$store.dispatch('errorMessage/resetError');
        await laboAPI.deleteLabo(item._id);
        this.deleteDialog = false;
        this.deleteQueue = {};
        await this.getAllLabos();
      } catch (err) {
        await this.$store.dispatch('errorMessage/setError', { message: err.message, code: err.statusCode });
      } finally {
        this.loading = false;
      }
    },
    fetchLabs(URLparams) {
      return laboAPI.getAllResults(URLparams);
    },
    async getAllLabos() {
      try {
        this.loading = true;
        const {
          data: { results, total },
        } = await laboAPI.getAllResults(this.$route.query);
        this.labos = results;
        this.total = total;
      } catch (err) {
        await this.$store.dispatch('errorMessage/setError', { message: err.message, code: err.statusCode });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
